// 被请求书 billableBase
import request from '@/utils/request'

// 履歴数据
export function getHistoryList(data) {
  return request({
    url: `/api/billableBase/historyList?id=${data}`,
    method: 'get',
    data,
  })
}

// 内訳・明細一覧 基本数据
export function getDetailData(data) {
  return request({
    url: `/api/billableBase/detailData?id=${data}`,
    method: 'get',
    data,
  })
}

// 内訳・明細一覧 父子表数据
export function getBasicInfoData(data) {
  return request({
    url: `/api/billableBase/billableBreakdownTableData?id=${data}`,
    method: 'get',
    data,
  })
}
